/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Relationship_OtherInputs */



/**
* | output |
* | --- |
* | "Other" |
*
* @param {Team_Relationship_OtherInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_relationship_other = /** @type {((inputs?: Team_Relationship_OtherInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Relationship_OtherInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Andere")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autre")
	return /** @type {LocalizedString} */ ("Other")
});